<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
var $ = require("jquery");
require("bootstrap/dist/css/bootstrap.min.css");
require("simple-line-icons/css/simple-line-icons.css");
import bootstrap from "bootstrap";

import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: {
    Navbar
  }
};
</script>

<style lang="scss" src="@/styles/styles.scss">
</style>



// WEBPACK FOOTER //
// src/App.vue